import { useMutation } from 'react-query';
import { CreateNotification } from 'mdello-client-ts';
import { useNotification } from 'src/providers/notificationsProvider';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { getClient } from 'src/util/mdello-instance';
import { UseAddContentModelMutationParams } from '../contentModels/mutations/useAddContntModelMutation/interfaces/useAddContentModelMutation.interface';

const createNotification = async (data: CreateNotification) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  getClient()?.createNotification(currentProject?._id, data);
};

export const useCreateNotifications = ({
  onError,
  onSuccess
}: UseAddContentModelMutationParams) => {
  const { notify } = useNotification();

  return useMutation((data: CreateNotification) => createNotification(data), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Notification Created Successfully' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
